import { capitalize } from 'lodash';

interface IdObject {
	id: string;
	testId: string;
}

class IdGeneratorService {
	formId?: string;

	constructor(id?: string) {
		this.formId = `${id}-form`;
	}

	generateLabel(id: string): string {
		return capitalize(id);
	}

	private generateTestId(id: string): string {
		return `${id}_test`;
	}

	private generateComponentIds(
		id: string,
		type: string,
		isForm = false,
	): IdObject {
		const initialId = isForm
			? `${this.formId}_${id}-${type}`
			: `${id}-${type}`;

		return {
			id: initialId,
			testId: this.generateTestId(initialId),
		};
	}

	generateInputIds(id: string): IdObject {
		return this.generateComponentIds(id, 'input');
	}

	generateCheckboxIds(id: string): IdObject {
		return this.generateComponentIds(id, 'checkbox');
	}

	generateDropdownIds(id: string): IdObject {
		return this.generateComponentIds(id, 'dropdown');
	}

	generateButtonIds(id: string): IdObject {
		return this.generateComponentIds(id, 'button');
	}

	generateFormInputIds(id: string): IdObject {
		return this.generateComponentIds(id, 'input', true);
	}

	generateFormCheckboxIds(id: string): IdObject {
		return this.generateComponentIds(id, 'checkbox', true);
	}

	generateFormDropdownIds(id: string): IdObject {
		return this.generateComponentIds(id, 'dropdown', true);
	}

	generateFormButtonIds(id: string): IdObject {
		return this.generateComponentIds(id, 'button', true);
	}
}

export default IdGeneratorService;
